import { Participant } from '@seen/core/models/patients/participant'
import { useMemo } from 'react'
import { useSearchResourcePages } from '#src/hooks/useSearchResourcePages.ts'

export function useParticipants(): Participant[] {
  const { data: participants } = useSearchResourcePages(
    Participant,
    Participant.baseSearchQuery()
  )

  return useMemo(() => {
    if (!participants) {
      return EMPTY_PARTICIPANTS
    }

    // Sort: non-leads first, then leads
    return [...participants].sort((a, b) => Number(a.isLead) - Number(b.isLead))
  }, [participants])
}

const EMPTY_PARTICIPANTS: Participant[] = []
